import { HomeApiResponse } from './types';

const API_BASE_URL = 'https://vlsiapi.bssoftcrm.com';

// GET API - Fetch home page content
export const fetchHomeContent = async (): Promise<HomeApiResponse> => {
  try {
    const response = await fetch(`${API_BASE_URL}/Home`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: HomeApiResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching home content:', error);
    throw error;
  }
};
